import React from "react";
import "./styles.scss";

export default function ImportedQuantity({ importedQuantity }) {
  return (
    importedQuantity !== 0 && (
      <div className="imported-data-success">
        <p>
          Dados importados com sucesso: <span>{importedQuantity}</span>
        </p>
      </div>
    )
  );
}
